// extracted by mini-css-extract-plugin
module.exports = {"form":"serviceType-form_form__2BPNx","actions":"serviceType-form_actions__tAneS"};